// Script para configurar a meta tag do App Bridge com a API key
// Este script é executado imediatamente quando o módulo carrega
// IMPORTANTE: Para apps incorporados, a meta tag com a API key deve estar sempre presente e preenchida

(function setupShopifyApiKey() {
  const apiKey = import.meta.env.VITE_SHOPIFY_API_KEY || '';
  
  if (apiKey) {
    // Tentar encontrar a meta tag pelo ID primeiro
    let metaTag = document.getElementById('shopify-api-key-meta');
    
    // Se não encontrou pelo ID, tentar pelo name
    if (!metaTag) {
      metaTag = document.querySelector('meta[name="shopify-api-key"]');
    }
    
    // Se ainda não encontrou, criar uma nova meta tag
    if (!metaTag) {
      metaTag = document.createElement('meta');
      metaTag.setAttribute('name', 'shopify-api-key');
      metaTag.id = 'shopify-api-key-meta';
      document.head.appendChild(metaTag);
    }
    
    // Sempre atualizar o conteúdo, mesmo se já tiver valor
    // Isso garante que a API key esteja sempre correta
    metaTag.setAttribute('content', apiKey);
  }
})();

